export const COINFLIP_ADDRESS = "0x81Fb1A0A1970e53806a0b2F7Bab0fdF165b237AE"; // VRF v2 on Goerli
export const SUPPORTED_CHAINS = [80001];
export const WAITFOR_CONFIRMATIONS = 2;
